import styled, { css } from 'styled-components';

export const MatchingHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: ${({ theme }) => theme.background.primary};
	padding: ${({ theme }) => theme.padding.edge};
`;

export const MatchingContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);

	& > div:nth-child(n) {
		border-right: 2px dashed ${({ theme }) => theme.color.primary};
	}

	& > div:nth-child(3n + 1) {
		border-left: 2px dashed ${({ theme }) => theme.color.primary};
	}
`;

export const MatchingFilter = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center;
	padding: ${({ theme }) => theme.padding.edge};
	border-bottom: 2px dashed ${({ theme }) => theme.color.primary};
	min-height: 3rem;
	gap: 1rem;
`;

export const MatchingFilterTitle = styled.div`
	color: ${({ theme }) => theme.color.primary};
	font-weight: 600;
`;

export const MatchingFilterHeader = styled.div<{ active?: boolean }>`
	border-color: white !important;
	background-color: ${({ theme }) => theme.background.primary};
	min-height: 4rem;
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center;
	padding: ${({ theme }) => theme.padding.edge};
	color: white;
	font-weight: bold;
	cursor: pointer;

	${({ active }) =>
		active &&
		css`
			background-color: #0063da;
		`}
`;
